import { configureStore } from "@reduxjs/toolkit";
import React from "react";
import { TypedUseSelectorHook, createDispatchHook, createSelectorHook } from "react-redux";
import licenseSlice from "./licenseSlice";

export const LicenseContext = React.createContext(null);

const licenseStore = configureStore({
    reducer: {
        licenseStore: licenseSlice,
    },
});
export default licenseStore;

export type State = ReturnType<typeof licenseStore.getState>;
export type Dispatch = typeof licenseStore.dispatch;
export const useLicenseSelector: TypedUseSelectorHook<State> = createSelectorHook(LicenseContext);
export const useLicenseDispatch = createDispatchHook<Dispatch>(LicenseContext);
